module.exports = require("stringz");;